/**
 * Sub contratos
 *
 */
import React from 'react'
import { Page } from '../../components'
import { SubContratistaProyectos } from './Components/SubContratosList'
import { EstimacionesTableList } from './Estimaciones/Table'

function SubContratosPage() {
  const [subContratoId, setSubContratoId] = React.useState(null)

  return (
    <Page>
      <div style={{ padding: 15, flex: 1, display: 'flex', overflowY: 'auto' }}>
        {/* maestro */}
        <div style={{ display: 'flex', marginRight: 20 }}>
          <SubContratistaProyectos
            seleccionadoId={subContratoId}
            onSelect={key => setSubContratoId(key)}
            style={{ flex: 1 }}
          />
        </div>

        {/* detalle */}
        <EstimacionesTableList
          subContratoId={subContratoId}
        />
      </div>
    </Page>
  )
}



export default SubContratosPage
